/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationsForbiddenError
 */
export interface NotificationsForbiddenError {
    /**
     * 
     * @type {number}
     * @memberof NotificationsForbiddenError
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof NotificationsForbiddenError
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsForbiddenError
     */
    message: string;
}

/**
 * Check if a given object implements the NotificationsForbiddenError interface.
 */
export function instanceOfNotificationsForbiddenError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function NotificationsForbiddenErrorFromJSON(json: any): NotificationsForbiddenError {
    return NotificationsForbiddenErrorFromJSONTyped(json, false);
}

export function NotificationsForbiddenErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationsForbiddenError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'title': json['title'],
        'message': json['message'],
    };
}

export function NotificationsForbiddenErrorToJSON(value?: NotificationsForbiddenError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'title': value.title,
        'message': value.message,
    };
}

